export const useRouter = () => {
    return {
        push: (path: string) => window.location.assign(path),
        replace: (path: string) => window.location.replace(path),
        prefetch: () => { },
        back: () => window.history.back(),
    };
};

export const usePathname = () => {
    return window.location.pathname;
};

export const useSearchParams = () => {
    return new URLSearchParams(window.location.search);
};

export const notFound = () => {
    // In React Router, we can throw an error or just redirect
    // For now, let's just log and show a message
    console.warn("Next.js notFound() called");
    window.location.assign('/404');
};

export default { useRouter, usePathname, useSearchParams, notFound };
